<app-modal *ngIf="isShow" [isShow]="isShow" (close)="handleClose()">
  <!-- Only umbraco media -->
  <video *ngIf="data.video.type === UMEDIA_TYPE" controls="true" autoplay="false" name="media" class="video-panel__video">
    <source [src]="data.video.url" type="video/mp4">
  </video>

  <!-- Other sources -->
  <app-iframe
    *ngIf="data.video.type !== UMEDIA_TYPE"
    class="video-panel__video"
    [src]="data.video.url"
    [params]="data.params">
  </app-iframe>

  <h3 *ngIf="data.title" class="video-panel__title">{{data.title.value}}</h3>
  <div *ngIf="data.description" class="video-panel__descr" [innerHTML]="data.description.value"></div>
</app-modal>
